import { getMarket, getMarketMetadata } from './market';

export const currency = (number: string | number | null): string => {
  if (Number.isNaN(number)) return '';

  const market = getMarket();
  if (!market) return number!.toString();

  const { currencySymbol, currencySymbolBefore } = getMarketMetadata();
  return currencySymbolBefore ? `${currencySymbol} ${number}` : `${number} ${currencySymbol}`;
};
